import { createContext, useEffect, useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Agreement from '../../components/creditInfoForm/steps/agreement'
import { useGlobalContext } from '../globalContext';
import useStepThreeValues from './stepThreeValues';

export const ContactInfoChangeStepsContext = createContext(null);

export function ContactInfoChangeStepsContextProvider({ children }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const {
    globalData: { status },
  } = useGlobalContext();
  const { stepThreeValues, setStepThreeValues } = useStepThreeValues();


  const [redirectUrl, setRedirectUrl] = useState(null);

  const [activeStep, setActiveStep] = useState({
    id: 1,
    component: <Agreement />,
    route: `/ContactInfoChange/agreement/${i18n.language}`,
  });


  const steps = useMemo(
    () => [
      {
        id: 1,
        title: t('confirmationStep1'),
        disabled: true,
        route: `/ContactInfoChange/agreement/${i18n.language}`,
      },
      {
        id: 2,
        title: t('identificationStep2'),
        disabled: status !== 'approved',
        route: `/ContactInfoChange/Identomat/${i18n.language}`,
      },
      {
        id: 3,
        title: t('identityInformation3'),
        disabled: status !== 'approved',
        route: `/ContactInfoChange/step/3`,
      },
      {
        id: 4,
        title: t('identityInformation6'),
        disabled: status !== 'approved',
        route: `/ContactInfoChange/step/4`,
      },
    ],
    [status, i18n.language, t]
  );



  const nextStep = () => {
    steps.forEach((step) => {
      if (step.id === activeStep.id + 1) {
        history.push(step.route);
      }
    });
  };

  const prevStep = () => {
    if (activeStep.id - 1 !== 2) {
      steps.forEach((step) => {
        if (step.id === activeStep.id - 1) {
          history.push(step.route);
        }
      });
    }
  };

  return (
    <ContactInfoChangeStepsContext.Provider
      value={{
        activeStep,
        nextStep,
        prevStep,
        redirectUrl,
        setRedirectUrl,
        steps,
        setActiveStep,
        stepThreeValues,
        setStepThreeValues,
      }}
    >
      {children}
    </ContactInfoChangeStepsContext.Provider>
  );
}

export function useContactInfoChangeStepsContext() {
  const value = useContext(ContactInfoChangeStepsContext);
  if (!value) {
    throw new Error('creditInfo Steps context Provider is not defined');
  }
  return value;
}
